var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpense(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.499,
    height: 31.499,
    viewBox: "0 0 31.499 31.499",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bill-1--billing-bills-payment-finance-cash-currency-money-accounting",
    transform: "translate(-2.679 -2.679)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M30.928,3.429h-25a2.5,2.5,0,0,0-2.5,2.5V19.053a2.5,2.5,0,0,0,2.5,2.5h25a2.5,2.5,0,0,0,2.5-2.5V5.929A2.5,2.5,0,0,0,30.928,3.429Z",
    fill: "none",
    stroke: "#ed3237",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.607,18.214a3.75,3.75,0,1,0-3.75-3.75A3.75,3.75,0,0,0,22.607,18.214Z",
    transform: "translate(-4.179 -1.973)",
    fill: "none",
    stroke: "#314286",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.143,36.429h27.5",
    transform: "translate(-0.464 -8.938)",
    fill: "none",
    stroke: "#314286",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M8.571,44.571h22.5",
    transform: "translate(-1.393 -11.144)",
    fill: "none",
    stroke: "#314286",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(7.241 11.866)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    d: "M9.282,16.25a.625.625,0,1,1,0-1.25",
    transform: "translate(-8.657 -15)",
    fill: "none",
    stroke: "#314286",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    d: "M9.514,16.25a.625.625,0,1,0,0-1.25",
    transform: "translate(-8.889 -15)",
    fill: "none",
    stroke: "#314286",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(28.366 11.866)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_1_2",
    "data-name": "Ellipse 1_2",
    d: "M38.254,16.25a.625.625,0,0,1,0-1.25",
    transform: "translate(-37.629 -15)",
    fill: "none",
    stroke: "#314286",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_2_2",
    "data-name": "Ellipse 2_2",
    d: "M38.486,16.25a.625.625,0,1,0,0-1.25",
    transform: "translate(-37.861 -15)",
    fill: "none",
    stroke: "#314286",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpense);
export default __webpack_public_path__ + "static/media/expense.41da722792054b02f7e8497cf346b474.svg";
export { ForwardRef as ReactComponent };